module.exports = __webpack_public_path__ + "media/tile-4-image.6494ef5f.png";